
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 720 480"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D21034","d":"M0 0h720v480H0z"}}),_c('g',{attrs:{"fill":"#007E3A"}},[_c('path',{attrs:{"d":"M120 120h480v240H120z"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"390","cy":"240","r":"80"}}),_c('circle',{attrs:{"cx":"420","cy":"240","r":"80"}})])])
          )
        }
      }
    